<template>
  <b-card
    header="Buttons">
    <draggable
      v-model="pkgButtons.buttons"
      :group="`${device}-btn`"
      handle=".drag-title">
      <transition-group>
        <b-card
          v-for="(pkgButton, i) in pkgButtons.buttons"
          :key="`${device}-${i}-btn`"
          class="mb-2"
          no-body>
          <b-card-header
            class="d-flex drag-title"
            header-bg-variant="transparent"
            header-tag="header"
            role="tab">
            <b-icon
              icon="grip-vertical"
              class="align-self-center" />
            <div
              v-b-toggle="`${device}-${i}-pkgbtn`"
              class="pl-1 w-100 d-flex justify-content-between align-items-center"
              @click.prevent="btnOpen = btnOpen === i ? null : i">
              {{ pkgButton.text }}
              <b-icon
                :icon="i === btnOpen ? `chevron-down` : `chevron-right`"
                class="align-self-center ml-auto"
                variant="secondary"
                scale="1.2" />
            </div>
          </b-card-header>
          <b-collapse
            :id="`${device}-${i}-btn`"
            :visible="btnOpen === i"
            :accordion="`${device}-btn`"
            role="tabpanel">
            <b-card-body>
              <b-form-group>
                <b-checkbox
                  v-model="pkgButton.enabled"
                  switch>
                  Enabled
                </b-checkbox>
              </b-form-group>

              <paywall-form-input
                :required="i === 0"
                :device="device"
                label="text"
                :config="pkgButton"
                config-key="text" />

              <paywall-form-input
                description="An optional field for setting a SKU on a package buy button"
                :device="device"
                :config="pkgButton"
                :placeholder="pkgButton.sku"
                :char-max="200"
                label="SKU"
                config-key="sku" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </transition-group>
    </draggable>
  </b-card>
</template>

<script>
import draggable from "vuedraggable"
import PaywallFormInput from "@/components/PaywallV1/PaywallFormInput"

export default {
  name: "PaywallFormPackageButtons",
  components: {PaywallFormInput, draggable},
  props: {
    pkgButtons: {
      type: Object,
      required: true,
    },
    device: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      btnOpen: null,
    }
  },
}
</script>

<style scoped>
.drag-title {
  border: 1px solid transparent;
}

.drag-title:hover > div > .bi-chevron-right {
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon;
}

.drag-title:hover {
  border: 1px solid var(--primary);
  transition: all 50ms ease;
  cursor: grab;
}

.drag-title:active, .drag-title:focus {
  cursor: grabbing;
  color: white;
  background: darkgrey;
  transform: scale(1.06);
  transition: transform 50ms ease;
}
</style>
